import i18next from "app/localization/localization";
import { LocalizationType } from "app/constants/localizationConst";

export const changeLanguage = (locale: string) => {
  i18next.changeLanguage(locale);
  localStorage.setItem(LocalizationType.SELECTED_LANG, locale);
};
